<button
  type="button"
  id="dropdownLanguageSelectorButton"
  data-dropdown-toggle="dropdownLanguageSelector"
  class="flex items-center gap-2 text-white language-selector-button"
>
  <img [src]="languageSelected.flag" alt="Flag" class="w-[20px]" />
  {{ languageSelected.name }}
  <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
  </svg>
</button>

<!-- Dropdown select language -->
<div
  id="dropdownLanguageSelector"
  class="z-10 hidden bg-white divide-y divide-gray-100 rounded shadow w-[90px] dark:bg-gray-700"
>
  <ul class="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownLanguageSelectorButton">
    <li
      *ngFor="let language of languages"
      (click)="langChanged(language)"
      class="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-200"
    >
      <img [src]="language.flag" alt="Flag" class="w-[20px]" />
      {{ language.name }}
    </li>
  </ul>
</div>
